import { create } from 'zustand'; // 'create' fonksiyonunu named import olarak alıyoruz

export const useThemeStore = create((set) => ({
  theme: localStorage.getItem('theme') || 'light', // Varsayılan tema
  toggleTheme: () =>
    set((state) => {
      const newTheme = state.theme === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme', newTheme); // Save theme to localStorage
      document.body.classList.remove(state.theme);  // Remove previous theme
      document.body.classList.add(newTheme);  // Add the new theme
      return { theme: newTheme };
    }),
}));
